import { FC } from 'react'
import React from 'react'

import Link, { ILinkProps } from '../link/Link'

export interface ILinkPhoneNumberProps extends ILinkProps {
  phoneNumber: string
}

const LinkPhoneNumber: FC<ILinkPhoneNumberProps> = ({
  phoneNumber,
  ...rest
}) => {
  return <Link {...rest} href={`tel:${phoneNumber}`} />
}

export default LinkPhoneNumber
